import { UserType } from '@/connect';

// formatUserIdentifier formats a user string from the API for displaying
// this will handle some of the special values the user string can contain
// or otherwise just display the user string (usually an email address if it's not a special value)
export function formatUserIdentifier(user: string): string {
  switch (user) {
    case UserType[UserType[user]]:
      return `${UserType[UserType[user]]}`.toLowerCase().replaceAll('_', ' ');
    default:
      return user;
  }
}
